document.addEventListener('DOMContentLoaded', function() {
  const hamburger = document.querySelector('.hamburger');

  if (hamburger) {
    hamburger.addEventListener('click', function() {
      document.body.classList.toggle('menu_open');
    });
  }
});

window.selectVariant = function(element, productId) {
  if (!element) return;

  const parent = element.parentElement;
  if (!parent) return;

  const siblings = parent.querySelectorAll('.color-dot');

  siblings.forEach(function(dot) {
    dot.classList.remove('active');
  });

  element.classList.add('active');

  const variantId = element.getAttribute('data-variant-id');
  const input = document.getElementById('variant-' + productId);

  if (input && variantId) {
    input.value = variantId;
  }
};

// ===== CART DRAWER =====
// ÖNEMLİ:
// Bu dosya ürün ekleme formu yakalamaz.
// Sepete ekleme sadece grid dosyasındaki bindAddToCartForms() ile yapılır.
// Drawer içindeki + / - ise sadece mevcut cart item quantity günceller.
(function() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');
  const body = document.getElementById('cart-drawer-body');
  const footer = document.getElementById('cart-drawer-footer');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  const strings = window.cartDrawerStrings || {};

  if (!drawer || !body) return;

  let isUpdating = false;
  let currentCart = null;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents) {
    return (Number(cents || 0) / 100).toLocaleString('da-DK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' kr';
  }

  function openDrawer() {
    drawer.classList.add('open');

    if (overlay) {
      overlay.classList.add('active');
    }

    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('open');

    if (overlay) {
      overlay.classList.remove('active');
    }

    document.body.style.overflow = '';
  }

  function setLoading(state) {
    isUpdating = state;
    drawer.classList.toggle('cart-drawer--loading', state);

    body.querySelectorAll('button').forEach(function(button) {
      button.disabled = state;
    });
  }

  function updateCartCount(cart) {
    if (!cart) return;

    const cartCountElements = document.querySelectorAll('.cart-count');

    cartCountElements.forEach(function(el) {
      el.textContent = cart.item_count > 99 ? '99+' : cart.item_count;

      if (cart.item_count > 0) {
        el.classList.add('is-visible');
      } else {
        el.classList.remove('is-visible');
      }
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Cart could not be loaded.');
      }

      return response.json();
    });
  }

  function renderCart(cart) {
    currentCart = cart;
    body.innerHTML = '';

    updateCartCount(cart);

    if (!cart || cart.item_count === 0 || !cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">' + escapeHtml(strings.empty || 'Your cart is currently empty.') + '</p>';

      if (footer) {
        footer.style.display = 'none';
      }

      return;
    }

    cart.items.forEach(function(item) {
      if (!item || Number(item.quantity || 0) <= 0) return;

      const itemKey = item.key || '';
      const imageUrl = item.image || '';

      const el = document.createElement('div');
      el.className = 'cart-drawer__item';
      el.setAttribute('data-cart-key', itemKey);

      const imgHtml = imageUrl
        ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.title || item.product_title || '') + '">'
        : '';

      el.innerHTML = `
        ${imgHtml}
        <div class="cart-drawer__item-info">
          <div class="cart-drawer__item-title">${escapeHtml(item.product_title || item.title)}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-variant">${escapeHtml(item.variant_title)}</div>` : ''}
          <div class="cart-drawer__qty">
            <button type="button" class="cart-drawer__qty-btn" data-action="minus" data-cart-key="${escapeHtml(itemKey)}">−</button>
            <span class="cart-drawer__qty-value">${Number(item.quantity || 0)}</span>
            <button type="button" class="cart-drawer__qty-btn" data-action="plus" data-cart-key="${escapeHtml(itemKey)}">+</button>
          </div>
          <div class="cart-drawer__item-price">${formatMoney(item.line_price)}</div>
          <button type="button" class="cart-drawer__remove" data-cart-key="${escapeHtml(itemKey)}">
            ${escapeHtml(strings.remove || 'Remove')}
          </button>
        </div>
      `;

      body.appendChild(el);
    });

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    if (footer) {
      footer.style.display = 'block';
    }
  }

  function changeItem(key, quantity) {
    if (isUpdating || !key) return;

    quantity = parseInt(quantity, 10);

    if (isNaN(quantity) || quantity < 0) {
      quantity = 0;
    }

    const cart = currentCart;

    if (!cart || !cart.items || !cart.items.length) {
      return fetchCart().then(function(freshCart) {
        currentCart = freshCart;
        changeItem(key, quantity);
      });
    }

    const targetExists = cart.items.some(function(item) {
      return item.key === key;
    });

    if (!targetExists) {
      console.warn('Cart item key not found:', key);
      return;
    }

    const updates = {};

    cart.items.forEach(function(item) {
      if (!item || !item.key) return;

      updates[item.key] = item.key === key ? quantity : Number(item.quantity || 0);
    });

    setLoading(true);

    /*
      cart/change.js yerine cart/update.js kullanıyoruz.
      Böylece sadece mevcut cart item key'leri güncellenir.
      Yeni ürün ekleme ihtimali ortadan kalkar.
    */
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        updates: updates
      })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().catch(function() {
            return {};
          }).then(function(errorData) {
            console.error('Shopify cart/update.js error:', errorData);
            throw new Error('Cart item could not be updated.');
          });
        }

        return response.json();
      })
      .then(function(updatedCart) {
        renderCart(updatedCart);
      })
      .catch(function(error) {
        console.error(error);

        fetchCart().then(function(freshCart) {
          renderCart(freshCart);
        });
      })
      .finally(function() {
        setLoading(false);
      });
  }

  body.addEventListener('click', function(e) {
    const qtyBtn = e.target.closest('.cart-drawer__qty-btn');

    if (qtyBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (isUpdating) return;

      const qtyWrapper = qtyBtn.closest('.cart-drawer__qty');
      const qtyValue = qtyWrapper ? qtyWrapper.querySelector('.cart-drawer__qty-value') : null;
      const currentQty = qtyValue ? parseInt(qtyValue.textContent, 10) || 0 : 0;
      const action = qtyBtn.getAttribute('data-action');
      const key = qtyBtn.getAttribute('data-cart-key');

      let newQty = currentQty;

      if (action === 'plus') {
        newQty = currentQty + 1;
      }

      if (action === 'minus') {
        newQty = currentQty - 1;
      }

      if (newQty < 0) {
        newQty = 0;
      }

      changeItem(key, newQty);
      return;
    }

    const removeBtn = e.target.closest('.cart-drawer__remove');

    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (isUpdating) return;

      const key = removeBtn.getAttribute('data-cart-key');

      changeItem(key, 0);
    }
  }, true);

  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      closeDrawer();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  window.HBCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    render: renderCart,
    refresh: function() {
      return fetchCart().then(function(cart) {
        renderCart(cart);
        return cart;
      });
    },
    refreshAndOpen: function() {
      return fetchCart().then(function(cart) {
        renderCart(cart);
        openDrawer();
        return cart;
      });
    }
  };

  fetchCart().then(function(cart) {
    renderCart(cart);
  }).catch(function(error) {
    console.error(error);
  });
})();